import * as React from "react";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import * as globals from "app/resources/globals";
import { esFolio } from "app/logic/guias";
import * as history from "app/main/history";

interface Props {
    match: match<{ folio: string }>
}
class RastreoGuiaCompNotRx extends React.PureComponent<Props> {

    folio = (props: Props) => this.props.match.params.folio;

    componentDidMount() {
        const folio = this.folio(this.props);
        const folios = [
            folio,
        ].filter(x => esFolio(x));
        globals.setState(prev => ({ ...prev, rastreo: { folios: folios, forzarState: true } }));
        history.go("/operativa/rastreo");
    }

    render() {
        return (<div> </div>
        )
    }

}

export const RastreoGuia = withRouter(RastreoGuiaCompNotRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/rastreoguia.tsx